import {
  GET_ADMIN_USERS_LIST_REQUEST,
  GET_ADMIN_USERS_LIST_SUCCESS,
  GET_ADMIN_USERS_LIST_FAILURE,
  SET_ADMIN_USERS_LIST_PAGE,
} from './UsersList.constant';
import { IGetAdminUsersResponse } from './UsersList.type';

export const getAdminUsersListRequest = (query?: string) => ({
  type: GET_ADMIN_USERS_LIST_REQUEST,
  payload: query,
});

export const getAdminUsersListSuccess = (payload: IGetAdminUsersResponse) => ({
  type: GET_ADMIN_USERS_LIST_SUCCESS,
  payload,
});

export const getAdminUsersListFailure = (payload: unknown) => ({
  type: GET_ADMIN_USERS_LIST_FAILURE,
  payload,
});

export const setAdminUsersListPage = (payload: number) => ({
  type: SET_ADMIN_USERS_LIST_PAGE,
  payload,
});
